import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const alias = "/offers/offer-clinics";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getOffersList = (params) =>
  ConfigCmsApi.get(alias, { params, headers: headers() });

const getOffer = (id) =>
  ConfigCmsApi.get(`${alias}/${id}`, { headers: headers() });

const createOffer = (data) =>
  ConfigCmsApi.post(alias, data, { headers: headers() });

const updateOffer = (id, data) =>
  ConfigCmsApi.put(`${alias}/${id}`, data, { headers: headers() });

const deleteOffer = (id) =>
  ConfigCmsApi.delete(`${alias}/${id}`, { headers: headers() });

const setScore = (id, score) =>
  ConfigCmsApi.patch(`${alias}/${id}/score/${score}`, {}, { headers: headers() });

export default {
  getOffersList,
  getOffer,
  createOffer,
  updateOffer,
  deleteOffer,
  setScore,
};
